<template>
  <el-container direction="vertical" class="home" id="allClient">
    <el-header class="header_Div">锐单后台管理系统V2.0</el-header>
    <el-main class="LoginFormCss">
      <el-form ref="form" :model="form" label-width="70px">
        <el-form-item v-bind:class="{ 'form-group--error': $v.form.userName.$error }">
          <span slot="label">用户名:</span>
          <el-input v-model.trim="form.userName" @input="$v.form.userName.$touch()" style="width: 220px;" placeholder="请输入登录用户名"></el-input>
        </el-form-item>
        <span class="form-group_message" v-if='!$v.form.userName.required'>用户名不能为空</span>
        <span class="form-group_message" v-if='!$v.form.userName.minLength'>用户名不正确</span>
        <el-form-item v-bind:class="{ 'form-group--error': $v.form.password.$error }">
          <span slot="label">密&nbsp;&nbsp;&nbsp;码:</span>
          <el-input type="password" @input="$v.form.password.$touch()" v-model.trim="form.password"  style="width: 220px;" placeholder="请输入登录密码" minlength="6" maxlength="18"></el-input>
        </el-form-item>
        <div class="form-group_message_error" v-if='message'>{{message}}</div>
        <span class="form-group_message" v-if='!$v.form.password.required'>登录密码不能为空</span>
        <span class="form-group_message" v-if='!$v.form.password.minLength'>登录密码最少6位</span>
        <el-form-item>  
          <el-button type="primary" size="mini" v-on:click="onSubmit($v.form)">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
          <el-button type="text" size="mini">忘记密码？</el-button>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer class="footer_guide">
      <Footer></Footer>
    </el-footer>
  </el-container>

  
</template>
<script>
import Header from "./common/header";
import Footer from "./common/footer";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  data: function() {
    return {
      form: {
        userName: "",
        password: "",
        clientHeight: ""
      },
      message: "",
      structArray: []
    };
  },
  mounted: function() {
    if (this.common.matchMedia()) {
      $(".LoginFormCss").height(this.common.getDocHeight() - 60)
    }
    if (!this.common.getClient()) {
      $(".LoginFormCss").height(this.common.getDocHeight() - 60)
    }
  },
  validations: {
    form: {
      userName: {
        required,
        minLength: minLength(2)
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    onSubmit: function(valid) {
      valid.$touch(); //验证所有信息
      let self = this; // 定义一个变量指向vue实例
      if (!valid.$error) {
        self.http.post(
          '/user/login',
          {
            userName: this.form.userName,
            password: this.form.password
          },
          res => {
            if (res.success) {
              this.user.data = res.datas.data
              this.common.save(this.constants.sessions_key, res.datas.data)
              this.$router.push({name:'main',params:res.datas.data})
              // 返回正确的处理
            } else {
              // 返回错误的处理
              this.message = res.message;
            }
          }
        );
      }
    }
  }
};
</script>

<style scoped>

.LoginFormCss {
  margin-top: -60px;
  min-width: 96%;
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
}

.form-group_message {
  display: none;
  font-size: 0.95rem;
  color: #cc3333;
  margin-top: -12px;
  margin-bottom: 12px;
  margin-left: 5.2em;
}

.form-group_message_error {
  font-size: 0.95rem;
  color: #cc3333;
  margin-top: -12px;
  margin-bottom: 12px;
  margin-left: 5.2em;
}

.form-group--error + .form-group_message {
  display: block;
  color: #cc3333;
}

.form-group--error input,
.form-group--error input:focus,
.form-group--error input:hover,
.form-group--error textarea {
  border-color: #cc3333;
}

.header_Div {
  background-color: #0fa0ec;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  letter-spacing:2px;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue